import { sources } from '../api/sources';
import { IMemberDetails } from '../state/model';
import { Pages, SESSION_EXPIRED_STATUS_CODES } from './constants';

export const navigateToMembershipBillPay = async (
  membershipDetails: IMemberDetails,
  tags: object | undefined,
  history: { push: (page: string) => void },
  enforceAutopay: boolean = false
) => {
  try {
    const url = await sources.submitMembershipChange({
      sessionId: membershipDetails?.sessionId || '',
      tags: tags || {},
      enforceAutopay
    });
    if (url?.redirectUrl) {
      if (window.location.hostname === 'localhost') {
        //Note: local remote testing not testable e2e for payment due flows
        history.push(`${Pages.UpdateMembershipStatusPage}?sessionId=${membershipDetails.sessionId}`);
      } else {
        window.location.assign(url.redirectUrl);
      }
    } else history.push(Pages.SorryPage);
  } catch (e: any) {
    if (SESSION_EXPIRED_STATUS_CODES.includes(e?.error?.code)) {
      history.push(Pages.TimeoutError);
    } else {
      history.push(Pages.SorryPage);
    }
  }
};
